import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type TranslateEmailTemplateWithId = {
  idTranslateEmailTemplate: number;
};

// Базовый тип для общих полей перевода шаблона email
type TranslateEmailTemplateCommonFields = {
  subject: string;
  body: string;
  bodyHtml: string;
};

// Типы для WebSocket сообщений компонента translateEmailTemplates
type TranslateEmailTemplatesListMessage = WebSocketMessageWithFields<'language-email-template-translations', {
  translateEmailTemplates: unknown[];
}>;
type TranslateEmailTemplatesNotFoundMessage = WebSocketMessageEmpty<'language-email-template-translations-not-found'>;
type TranslateEmailTemplateCreateMessage = WebSocketMessageWithFields<'translate-email-template-create' | 'translate-email-template-create-success', TranslateEmailTemplateWithId & {
  idEmailTemplate: number;
  idLanguage: number;
} & TranslateEmailTemplateCommonFields>;
type TranslateEmailTemplateUpdateMessage = WebSocketMessageWithFields<'translate-email-template-update' | 'translate-email-template-update-success', TranslateEmailTemplateWithId & TranslateEmailTemplateCommonFields>;
type TranslateEmailTemplateDeleteMessage = WebSocketMessageWithFields<'translate-email-template-delete' | 'translate-email-template-delete-success', TranslateEmailTemplateWithId>;
type TranslateEmailTemplateLockMessage = WebSocketMessageWithFields<'translate-email-template-lock' | 'translate-email-template-lock-success', TranslateEmailTemplateWithId>;
type TranslateEmailTemplateUnlockMessage = WebSocketMessageWithFields<'translate-email-template-unlock' | 'translate-email-template-unlock-success', TranslateEmailTemplateWithId>;

// Объединенный тип для всех сообщений
type TranslateEmailTemplatesWebSocketMessage = 
  | TranslateEmailTemplatesListMessage 
  | TranslateEmailTemplatesNotFoundMessage 
  | TranslateEmailTemplateCreateMessage 
  | TranslateEmailTemplateUpdateMessage 
  | TranslateEmailTemplateDeleteMessage 
  | TranslateEmailTemplateLockMessage 
  | TranslateEmailTemplateUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataTranslateEmailTemplates',
},
  __name: 'translateEmailTemplates',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID перевода шаблона email
const handleWebSocketMessage = (data: TranslateEmailTemplatesWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'language-email-template-translations':
      store.dispatch('translateEmailTemplates/wsSetTranslateEmailTemplates', {
        translateEmailTemplates: data.translateEmailTemplates,
      });
      break;
    case 'language-email-template-translations-not-found':
      store.dispatch('emailTemplate/wsSetEmptyEmailTemplate');
      break;

    case 'translate-email-template-create':
    case 'translate-email-template-create-success':
      store.dispatch('translateEmailTemplates/wsTranslateEmailTemplateCreate', {
        idTranslateEmailTemplate: data.idTranslateEmailTemplate,
        idEmailTemplate: data.idEmailTemplate,
        idLanguage: data.idLanguage,
        subject: data.subject,
        body: data.body,
        bodyHtml: data.bodyHtml,
      });
      break;

    case 'translate-email-template-update':
    case 'translate-email-template-update-success':
      store.dispatch('translateEmailTemplates/wsTranslateEmailTemplateUpdate', {
        idTranslateEmailTemplate: data.idTranslateEmailTemplate,
        subject: data.subject,
        body: data.body,
        bodyHtml: data.bodyHtml,
      });
      break;

    case 'translate-email-template-delete':
    case 'translate-email-template-delete-success':
      store.dispatch('translateEmailTemplates/wsTranslateEmailTemplateDelete', {
        idTranslateEmailTemplate: data.idTranslateEmailTemplate,
      });
      break;

    case 'translate-email-template-lock':
    case 'translate-email-template-lock-success':
      store.dispatch('translateEmailTemplates/wsTranslateEmailTemplateLock', {
        idTranslateEmailTemplate: data.idTranslateEmailTemplate,
      });
      break;

    case 'translate-email-template-unlock':
    case 'translate-email-template-unlock-success':
      store.dispatch('translateEmailTemplates/wsTranslateEmailTemplateUnlock', {
        idTranslateEmailTemplate: data.idTranslateEmailTemplate,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})